export const outboundExternalLink = (outboundUrl: string) => {
  window.location.href = outboundUrl;
  return outboundUrl;
};
